import { TextSelection } from 'prosemirror-state'

import type { Command } from 'common/Prose/Commands'
import { getPreviousTextPosition } from 'common/Prose/utils'
import { schema } from 'prose-core'

export const deleteEmptyToggle: Command = ({ selection: { $from, empty }, tr }, dispatch) => {
  if (!empty) return false
  if ($from.pos !== $from.start()) return false
  if ($from.node().childCount !== 0) return false
  if ($from.node(-1).type !== schema.nodes.summary) return false

  tr.delete($from.before(-2), $from.after(-2))
  tr.setSelection(new TextSelection(getPreviousTextPosition(tr.selection.$from)))

  dispatch?.(tr)

  return true
}
